import Vue from 'vue'
import App from './App.vue'
import router from './router'
import config from './config'
import axios from 'axios'
import vuetify from './plugins/vuetify';
import store from './store'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './plugins/vue-moment'
import YfxCloudAuth from '@yodatech/vue-yfx-cloud-auth'
import YfxLicense from '@yodatech/vue-yfx-license'
import VueTimers from "vue-timers"

Vue.use(YfxCloudAuth, {serviceName: "global-logs-viewer", store: store, axios: axios, ...config.authConfig})
Vue.use(YfxLicense, {axios: axios})
Vue.use(VueTimers);

Vue.config.productionTip = false

Vue.prototype.$http = axios
Vue.prototype.$config = config

new Vue({
  router,
  vuetify,
  store,
  render: h => h(App)
}).$mount('#app')
